import { Close } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledModalHeaderWrapper = styled.header`
  padding: ${rem('15px')} ${rem('28px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
`;

export const StyledTitle = styled.h1`
  font-size: ${rem('24px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
`;

export const StyledCloseIcon = styled(Close)`
  width: ${rem('13px')};
  height: auto;
  color: ${({ theme }) => `${theme.colors.cross.deepBlu}`};
  cursor: pointer;
`;

export const StyledCloseButton = styled.button`
  top: ${rem('18px')};
  right: ${rem('16px')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  svg {
    display: block;
    width: ${rem('14px')};
    height: auto;
  }
`;
